import React from "react";
import { AlertTriangle } from "lucide-react";
import { buildRegulationLongformSections, getRegulationLongformCopy } from "@/lib/regulationLongformContent";

export default function RegulationLongformGuide({ lang = "en", title, country, topic }) {
  const copy = getRegulationLongformCopy(lang);
  const sections = buildRegulationLongformSections({ lang, title, country, topic });
  const isRtl = ["he", "ar"].includes(lang);

  return (
    <section dir={isRtl ? "rtl" : "ltr"} className="rounded-3xl border border-border bg-card p-6 shadow-xl md:p-8">
      <div className="mb-6 rounded-2xl border border-primary/20 bg-primary/10 p-5">
        <div className="inline-flex items-center gap-2 rounded-full bg-background px-4 py-2 text-sm font-black text-primary">
          <AlertTriangle className="h-4 w-4" /> {copy.badge}
        </div>
        <h2 className="mt-4 font-heading text-3xl font-black text-foreground">{copy.title}</h2>
        <p className="mt-3 text-base leading-8 text-muted-foreground">{copy.intro}</p>
        <p className="mt-3 text-sm font-semibold leading-7 text-foreground">{copy.official}</p>
      </div>
      <div className="space-y-7">
        {sections.map((section) => (
          <article key={section.heading} className="border-b border-border pb-6 last:border-b-0 last:pb-0">
            <h3 className="font-heading text-2xl font-bold text-foreground">{section.heading}</h3>
            <p className="mt-3 text-base leading-8 text-muted-foreground">{section.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}